import type { EligibilityResponse } from "@Light/services/lightTypes";
import { getUtilityBehavior } from "@Light/utils/utility";

/** Whether the customer has to pick or confirm their utility for an eligible zip. */
export function needsUtilityConfirmation(result: EligibilityResponse): boolean {
  return (
    result.utilities.length > 1 ||
    result.utilities.some(
      (utility) => getUtilityBehavior(utility.id).confirmFromZip,
    )
  );
}
